import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ac8c967c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac8c967c')) {
      api.createRecord('ac8c967c', component.options)
    } else {
      api.reload('ac8c967c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ac8c967c&", function () {
      api.rerender('ac8c967c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/like-dislike/index.vue"
export default component.exports